/**
 * Owner: Masa Bayu
 * File: qx-studio-mode.ts
 * Date:Time: 2026-10-24 20:10
 * Description: D2 · mod Studio (/author/studio) — Halaman vs Tulis, di luar komponen.
 */

import { useSyncExternalStore } from 'react';

export type QxStudioMode = 'pages' | 'write';

/**
 * `null` = belum diputuskan. Keputusan pertama dibuat oleh host selepas sesi
 * editor (IndexedDB) dibaca; selepas itu hanya penukar bar yang mengubahnya.
 */
let mode: QxStudioMode | null = null;
const listeners = new Set<() => void>();

function emit(): void {
  for (const listener of listeners) listener();
}

export function getQxStudioMode(): QxStudioMode | null {
  return mode;
}

export function setQxStudioMode(next: QxStudioMode): void {
  if (next === mode) return;
  mode = next;
  emit();
}

/** Setiap buka `/author/studio` mula semula — jangan kekalkan Halaman dari sesi pelayar dikongsi. */
export function resetQxStudioMode(): void {
  if (mode === null) return;
  mode = null;
  emit();
}

export function subscribeQxStudioMode(listener: () => void): () => void {
  listeners.add(listener);
  return () => {
    listeners.delete(listener);
  };
}

/** Bacaan reaktif host; tulis melalui `setQxStudioMode`. */
export function useQxStudioMode(): QxStudioMode | null {
  return useSyncExternalStore(subscribeQxStudioMode, getQxStudioMode);
}
